export type FormValidation = {
  regex: RegExp
  message: string
} | {
  validator: (value: string) => boolean | string
  message: string
}

export function createFormValidation(validations: FormValidation[]) {
  return Object.fromEntries(
    validations.map((validation) => {
      if ('regex' in validation) {
        return [
          validation.message,
          (value: string) => validation.regex.test(value) || validation.message,
        ]
      }
      return [
        validation.message,
        validation.validator,
      ]
    })
  )
}
